'use client';

import { useApi } from '@prismo-io/core';
import { useRouter } from 'next/navigation';
import { type FC, useEffect } from 'react';
type Props = {
  relationId: string;
};
export const ListenerStatusChange: FC<Props> = props => {
  const {
    relationId
  } = props;
  const {
    client
  } = useApi();
  const router = useRouter();
  useEffect(() => {
    if (!relationId) {
      return;
    }
    const channel = client.channel('tsid-status-change').on('postgres_changes', {
      event: 'UPDATE',
      schema: 'tsid',
      table: 'users_tools',
      filter: `id=eq.${relationId}`
    }, payload => {
      router.refresh();
    }).subscribe();
    return () => {
      client.removeChannel(channel);
    };
  }, [client, relationId, router]);
  return null;
};